export default {
  tableLoader(state, value) {
    return (state.tableLoading = value);
  },

  currentPage(state, value) {
    return (state.currentPage = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  filterDate(state, value) {
    return (state.filterDate = value);
  },

  toggleUploadDialog(state, value) {
    return (state.showUploadDialog = value ? value : !state.showUploadDialog);
  },

  payBreakdowns(state, value) {
    return (state.payBreakdowns = value);
  },

  totalPayBreakdown(state, total) {
    return (state.totalPayBreakdown = total);
  },

  extraAllowances(state, value) {
    return (state.extraAllowances = value);
  },

  totalExtraAllowance(state, total) {
    return (state.totalExtraAllowance = total);
  },

  companyRemittance(state, value) {
    return (state.companyRemittance = value);
  },

  totalCompanyRemittance(state, total) {
    return (state.totalCompanyRemittance = total);
  },

  batchingGroups(state, value) {
    return (state.batchingGroups = value);
  },

  totalBatchingGroup(state, total) {
    return (state.totalBatchingGroup = total);
  },
  branches(state, value) {
    return (state.branches = value);
  },
  departments(state, value) {
    return (state.departments = value);
  },
  employees(state, value) {
    return (state.employees = value);
  },
  employeeGrades(state, value) {
    return (state.employeeGrades = value);
  },
  teams(state, value) {
    return (state.teams = value);
  },
  statutoryDs(state, value) {
    return (state.statutoryDs = value);
  },

  totalStatutoryDs(state, total) {
    return (state.totalStatutoryDs = total);
  },
  currentCompanyRemittance(state, value) {
    return (state.currentCompanyRemittance = value);
  },
  currentStatutoryDeduction(state, value) {
    return (state.currentStatutoryDeduction = value);
  },
  allowanceName(state, value) {
    return (state.allowanceName = value);
  },
  currentPageForPayPackage(state, value) {
    return (state.currentPageForPayPackage = value);
  },
  perPageForPayPackage(state, value) {
    return (state.perPageForPayPackage = value);
  },
  payPackages(state, value) {
    return (state.payPackages = value);
  },
  totalPayPackages(state, value) {
    return (state.totalPayPackages = value);
  },
  currentPageForSalary(state, value) {
    return (state.currentPageForSalary = value);
  },
  perPageForSalary(state, value) {
    return (state.perPageForSalary = value);
  },
  salarySchedule(state, value) {
    return (state.salarySchedule = value);
  },
  totalSalarySchedule(state, value) {
    return (state.totalSalarySchedule = value);
  },
  formDataForSalarySchedule(state, value) {
    return (state.formDataForSalarySchedule = value);
  },
  currentPageForPaymentUploads(state, value) {
    return (state.currentPageForPaymentUploads = value);
  },
  perPageForPaymentUploads(state, value) {
    return (state.perPageForPaymentUploads = value);
  },
  paymentUploads(state, value) {
    return (state.paymentUploads = value);
  },
  totalPaymentUploads(state, value) {
    return (state.totalPaymentUploads = value);
  },
  formDataForUploadedSalarySchedule(state, value) {
    return (state.formDataForUploadedSalarySchedule = value);
  },
  formDataForASalarySchedule(state, value) {
    return (state.formDataForASalarySchedule = value);
  },
  paymentUploadDetails(state, value) {
    return (state.paymentUploadDetails = value);
  },
  totalPaymentUploadDetails(state, value) {
    return (state.totalPaymentUploadDetails = value);
  },
  perPageForPaymentUploadDetails(state, value) {
    return (state.perPageForPaymentUploadDetails = value);
  },
  currentPageForPaymentUploadDetails(state, value) {
    return (state.currentPageForPaymentUploadDetails = value);
  },
  approvedPayments(state, value) {
    return (state.approvedPayments = value);
  },
  totalApprovedPayments(state, value) {
    return (state.totalApprovedPayments = value);
  },
  currentPageForApprovedPayments(state, value) {
    return (state.currentPageForApprovedPayments = value);
  },
  perPageForApprovedPayments(state, value) {
    return (state.perPageForApprovedPayments = value);
  },
  approvedPaymentSchedules(state, value) {
    return (state.approvedPaymentSchedules = value);
  },
  totalApprovedPaymentSchedules(state, value) {
    return (state.totalApprovedPaymentSchedules = value);
  },
  currentPageForApprovedPaymentSchedules(state, value) {
    return (state.currentPageForApprovedPaymentSchedules = value);
  },
  perPageForApprovedPaymentSchedules(state, value) {
    return (state.perPageForApprovedPaymentSchedules = value);
  },
  currentPageForMandates(state, value) {
    return (state.currentPageForMandates = value);
  },
  perPageForMandates(state, value) {
    return (state.perPageForMandates = value);
  },
  mandates(state, value) {
    return (state.mandates = value);
  },
  totalMandate(state, value) {
    return (state.totalMandate = value);
  },
  companyStatutorySettings(state, value) {
    return (state.companyStatutorySettings = {
      ...state.companyStatutorySettings,
      ...value,
    });
  },
  setUploadedEmployeesForSalary(state, value) {
    return (state.uploadedEmployeesForSalaryId = value);
  },
};
